import useProductForm from 'hooks/useProductForm'
import ProductATC from 'snippets/product-atc/product-atc'
import ProductVariant from 'snippets/product-variant/product-variant'

function ProductGiftCardForm() {
  const { currentVariant, initProduct, updateCurrentVariant } = useProductForm()
  return (
    <div className="js-product-form">
      <ProductVariant
        variants={initProduct.variants}
        options={initProduct.options}
        updateCurrentVariant={updateCurrentVariant}
        currentVariant={currentVariant}
        updateUrl={true}
        displayType="dropdown"
      />

      <ProductATC
        currentVariant={currentVariant}
        updateCurrentVariant={updateCurrentVariant}
        initProduct={initProduct}
        buttonText="Add to cart"
        showStatus={false}
        buttonWrapperClass="mt-6"
      />
    </div>
  )
}

export default ProductGiftCardForm
